import { useEffect, useState } from 'react';

import { CalmTheme } from '@calm-web/design-system';

export function useIsMobile() {
	const [isMobile, setIsMobile] = useState(false);

	function updateMobile() {
		if (window.innerWidth < CalmTheme.breakpoints.desktop) {
			setIsMobile(true);
		} else {
			setIsMobile(false);
		}
	}

	useEffect(() => {
		// TODO: refactor this code to follow best practices
		// eslint-disable-next-line react-hooks/set-state-in-effect
		updateMobile();
		window.addEventListener('resize', updateMobile);
		return () => {
			window.removeEventListener('resize', updateMobile);
		};
	}, []);

	return [isMobile];
}
